import React from "react";
import TldrBase from "../TldrLogin/TldrBase";
import { Link } from "react-router-dom";
import { LOGIN } from "../_utils/routes";
import { FaArrowLeft } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { Box, Icon } from "@chakra-ui/react";

export const PasswordResetSuccess = () => {
  const { t } = useTranslation(["auth"]);
  return (
    <>
      <TldrBase
        subheading={t("reset_password.success.subheading")}
        heading={t("reset_password.success.heading")}
      >
        <Box className="input-group secondary-links center" mt={12}>
          <Link to={LOGIN} style={{ display: "flex", alignItems: "center" }}>
            <Icon as={FaArrowLeft} mr={1} />
            {t("reset_password.back")}
          </Link>
        </Box>
      </TldrBase>
    </>
  );
};

export const PasswordResetFailure = () => {
  const { t } = useTranslation(["auth"]);
  return (
    <>
      <TldrBase
        subheading={t("reset_password.failure.subheading")}
        heading={t("reset_password.failure.heading")}
      >
        <Box className="input-group secondary-links center" mt={12}>
          <Link to={LOGIN} style={{ display: "flex", alignItems: "center" }}>
            <Icon as={FaArrowLeft} mr={1} />
            {t("reset_password.back")}
          </Link>
        </Box>
      </TldrBase>
    </>
  );
};

// Password set from invitation link - SUCCESS
export const PasswordSetSuccessViaInvitation = () => {
  const { t } = useTranslation(["auth"]);
  return (
    <>
      <TldrBase
        subheading={t("set_password_invitation.success.subheading")}
        heading={t("set_password_invitation.success.heading")}
      >
        <Box className="input-group secondary-links center" mt={12}>
          <Link to={LOGIN} style={{ display: "flex", alignItems: "center" }}>
            <Icon as={FaArrowLeft} mr={1} />
            {t("set_password_invitation.success.back")}
          </Link>
        </Box>
      </TldrBase>
    </>
  );
};

// Password set from invitation link - FAILURE
export const PasswordSetFailureViaInvitation = () => {
  const { t } = useTranslation(["auth"]);
  return (
    <>
      <TldrBase
        subheading={t("set_password_invitation.failure.subheading")}
        heading={t("set_password_invitation.failure.heading")}
      >
        <Box className="input-group secondary-links center" mt={12}>
          <Link to={LOGIN} style={{ display: "flex", alignItems: "center" }}>
            <Icon as={FaArrowLeft} mr={1} />
            {t("set_password_invitation.failure.back")}
          </Link>
        </Box>
      </TldrBase>
    </>
  );
};

export const RegistrationVerificationSuccess = () => {
  const { t } = useTranslation(["auth"]);

  return (
    <>
      <TldrBase
        wrapperClassName="login-wrapper"
        showBackgroundImage
        subheading={t("registration_email.success.subheading")}
        heading={t("registration_email.success.heading")}
      >
        <Box className="input-group secondary-links center" mt={12}>
          <Link to={LOGIN}>
          <Icon as={FaArrowLeft} mr={1} />
            {t("registration_email.success.back")}
            
          </Link>
        </Box>
      </TldrBase>
    </>
  );
};

export const RegistrationVerificationFailure = () => {
  const { t } = useTranslation(["auth"]);

  return (
    <>
      <TldrBase
        wrapperClassName="login-wrapper"
        showBackgroundImage
        subheading={t("registration_email.failure.subheading")}
        heading={t("registration_email.failure.heading")}
      >
        <Box className="input-group secondary-links center" mt={12}>
          <Link to={LOGIN} style={{ display: "flex", alignItems: "center" }}>
            <Icon as={FaArrowLeft} mr={1} />
            {t("registration_email.failure.back")}
          </Link>
        </Box>
      </TldrBase>
    </>
  );
};
